import { Controller } from "@hotwired/stimulus"
import { postMessageToParent } from "../helpers/post_message_to_parent"

// Connects to data-controller="post-message-to-parent"
export default class extends Controller {
  connect() {
    this.element.dispatchEvent(new CustomEvent('connect'))
  }

  postMessage(event) {
    const message = event.params.message
    const origins = event.params.origin

    postMessageToParent(message, origins)
  }
}
